import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes, Router } from '@angular/router';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { PagesComponent } from './components/pages/pages.component';
import { MediaPlayerComponent } from './media-player/media-player.component';
import { ChannelsComponent } from './channels/channels.component';
import { LiveBroadcastComponent } from './live-broadcast/live-broadcast.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { ReviewMessagesComponent } from './review-messages/review-messages.component';
import { EventComponent } from './event/event.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { ChatComponent } from './components/chat/chat.component';
import { ElementsComponent } from './stripe/elements/elements.component';
import { NewsHomeComponent } from './news/news-home/news-home.component';
import { PagesService } from './services/pages.service';
import { PlayerComponent } from './player/player.component';

const routes: Routes = [
  { path: '', component: SignInComponent, pathMatch: 'full' },
  { path: 'page', component: PagesComponent },
  { path: 'sign-in', component: SignInComponent },
  {
    path: 'user-profile',
    component: UserProfileComponent
  },
  {
    path: `page/:articleId`, component: PagesComponent
  },
  { path: 'media-player', component: MediaPlayerComponent },
  { path: 'channels', component: ChannelsComponent },
  { path: 'live-broadcast', component: LiveBroadcastComponent },
  { path: 'register-user', component: SignUpComponent },
  { path: 'course-materials', loadChildren: './course-materials/course-materials.module#CourseMaterialsPageModule' },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent },
  { path: 'review-messages', component: ReviewMessagesComponent },
  { path: 'event-page', component: EventComponent },
  { path: 'modal', loadChildren: './modals/modal/modal.module#ModalPageModule' },
  { path: 'subscription-plans', component: SubscriptionPlansComponent },
  { path: 'card-form', component: ElementsComponent },
  { path: 'chat', component: ChatComponent },
  { path: 'news', component: NewsHomeComponent },
  { path: 'player', component: PlayerComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
  pageId: string;
  constructor(private pageService: PagesService, public router: Router) {
    this.pageService.getPage('dashboard').on('value', snapshot => {
      this.pageId = snapshot.val().id;
    });
  }
}
